import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router";

import CuteBanner from "../shopping/component/themes/cute/banner";
import ModernBanner from "../shopping/component/themes/modern/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";
import ProductList from "./component/productList";

import { Container } from "../common/styled";

import useQueryString from "../../../hooks/useQueryString";
import ProductIntro from "./component/productIntro";

const ProductsList = () => {
  const { theme, cmpnyNo } = useOutletContext();

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  // const contents = {
  //   4: ProductIntro,
  // };

  const renderContent = () => {
    const Banner = banners[theme];
    const Contents = theme === 4 ? ProductIntro : ProductList;

    return (
      <>
        {Banner && <Banner />}
        <Contents
        // nextPage={nextPage}
        // product={product}
        // totalCount={totalCount}
        // currentPage={currentPage}
        />
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderContent()}</Container>;
};

export default ProductsList;
